import React, { useEffect, useState } from "react";
import { isChunkLoadError, reloadForNewBuild } from "@/utility/chunkError";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const staleBuild = isChunkLoadError(error);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (staleBuild) setReloading(reloadForNewBuild());
  }, [staleBuild]);

  // A failed chunk means the tab is running against a build that no longer
  // exists on the server. Resetting the boundary can't fix that, so reload.
  if (staleBuild) {
    return (
      <div role="alert">
        <h5>A new version of the portal is available</h5>
        <p>{reloading ? "Reloading…" : "Reload the page to continue."}</p>
        {!reloading && (
          <button onClick={() => window.location.reload()}>Reload</button>
        )}
      </div>
    );
  }

  return (
    <div role="alert">
      <h5>There was an Error</h5>
      <pre style={{ whiteSpace: "normal" }}>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try Again</button>
    </div>
  );
};

export default ErrorFallback;
